import PropTypes from 'prop-types';
import React from 'react';
import FetchSpinner from '../components/Spinner';

export class InfinityPager extends React.PureComponent {
  tryLoadTimeout;

  static propTypes = {
    container: PropTypes.any,
    forceLoad: PropTypes.number,
    pageSize: PropTypes.number.isRequired,
    loadNext: PropTypes.func.isRequired,
    scrollThreshold: PropTypes.number,
    loadOnMount: PropTypes.bool,
  };

  static defaultProps = {
    scrollThreshold: 1200,
    loadOnMount: true,
  };

  constructor(props) {
    super(props);

    this.state = {
      infinityLoading: false,
    };

    this.tryLoad = this.tryLoad.bind(this);
  }

  componentDidMount() {
    this.mounted = true;
    if (this.props.loadOnMount) this.tryLoad(true);
  }

  componentDidUpdate(prevProps) {
    if (this.props.forceLoad && this.props.forceLoad !== prevProps.forceLoad) {
      this.tryLoad(true);
    }
  }

  componentWillUnmount() {
    this.mounted = false;
    this.disableInfinityLoading();
  }

  enableInfinityLoading() {
    this.disableInfinityLoading();
    const container = this.getContainer();
    container.addEventListener('scroll', this.tryLoad);
    container.addEventListener('resize', this.tryLoad);
    this.tryLoadTimeout = setTimeout(this.tryLoad, 0);
  }

  disableInfinityLoading() {
    const container = this.getContainer();
    container.removeEventListener('scroll', this.tryLoad);
    container.removeEventListener('resize', this.tryLoad);
    clearTimeout(this.tryLoadTimeout);
  }

  getContainer() {
    return this.props.container ? document.getElementById(this.props.container) : window;
  }

  tryLoad(force) {
    if (this.tryLoadTimeout) {
      clearTimeout(this.tryLoadTimeout);
    }

    const {scrollThreshold, loadNext, pageSize} = this.props;

    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    let scrollHeight = document.body.scrollHeight;
    let height = window.innerHeight;

    if (this.props.container) {
      const container = this.getContainer();
      scrollTop = container.scrollTop;
      scrollHeight = container.scrollHeight;
      height = container.clientHeight;
    }

    const loadMore = height > 0 && scrollTop + scrollThreshold >= scrollHeight - height;

    if (force === true || loadMore) {
      this.disableInfinityLoading();

      const lastAPICall = Date.now();
      this.lastAPICall = lastAPICall;
      this.setState({infinityLoading: true});

      loadNext().then((items) => {
        if (this.mounted && lastAPICall === this.lastAPICall) {
          this.setState({infinityLoading: false});

          if (items && items.length === pageSize) {
            this.enableInfinityLoading();
          }
        }
      });
    }
  }

  render() {
    if (this.state.infinityLoading) {
      return <FetchSpinner />;
    }

    return null;
  }
}
